import type {EventHashedID, EventVO} from "@Components/events/events.types";
import type {BasePanel} from "@Components/panel/panel.types";
import type {SocialPost} from "@Components/social-media/post.vo";
import type {EmailCampaign} from "@Components/email-marketing-campaigns/email-marketing-campaigns.types";
import type {LoadingStates} from "@Utils/loading.util";
import type {SocialAccount} from "@Components/social-media/account.vo";
import type {ContainerQueryObject} from "@Hooks/useContainerQuery";
import type {MailingListVO} from "@Components/email-marketing-campaign-audience/email-marketing-campaign-audience.types";

export const EVENT_ONE_CLICK_PROMO_PANEL_ID = 'eventOneClickPromoPanel';
export const ONE_CLICK_PROMO_PANEL_CONTAINER_QUERY: ContainerQueryObject = {
    small: {
        maxWidth: 760
    }
}

export const ONE_CLICK_EMAIL_PREVIEW_SKELETON_WIDTH = 112;
export const ONE_CLICK_POST_PREVIEW_SKELETON_DIMENSIONS = 126;

export const ONE_CLICK_TILE_HEADER_TEXT_SKELETON_WIDTH = 115;
export const ONE_CLICK_TILE_HEADER_SUBTEXT_SKELETON_WIDTH = 62;
export const ONE_CLICK_TILE_HEADER_TEXT_SKELETON_HEIGHT = 12;
export const ONE_CLICK_TILE_HEADER_SUBTEXT_SKELETON_HEIGHT = 8;

export interface EventOneClickPromotionPanelProps extends BasePanel {
    eventHashedId: EventHashedID;
}

export interface EventOneClickPromoReduxState {
    event: EventVO;
    loadingState: LoadingStates;
    socialPost: SocialPost;
    campaign: EmailCampaign;
    allSocialAccounts: SocialAccount[];
    allMailingLists: MailingListVO[];
    showPostLoader: boolean;
    showCampaignsLoader: boolean;
    campaignOneClickState: OneClickPromoItemState;
    socialPostOneCLickState: OneClickPromoItemState;
    postPublishFailMessage: string;
    emailPublishFailMessage: string;
    emailSends: number;
    doesUserHaveSenderProfile: boolean;
}

export interface OneClickDataReadyStatePollingResponse {
    isAvailable: boolean;
    data: EventOneClickPromoBackendResponse;
}

export interface EventOneClickPromoBackendResponse {
    event: EventVO;
    socialPost: SocialPost;
    campaign: EmailCampaign;
    accounts: SocialAccount[];
    mailingLists: MailingListVO[];
    emailSends: number;
    doesUserHaveSenderProfile: boolean;
}

export interface PostPublishingStatusPollingResponse {
    isAvailable: boolean;
    data: SocialPost;
}

export interface OneClickPromoTileBase {
    className?: string;
    showReversedContent?: boolean;
    isAIContentLoading?: boolean;
}

export const ONE_CLICK_PROMO_LOADING_TEXT_ROTATION_INTERVAL_MS = 3000;

export const ONE_CLICK_PROMO_SOCIAL_LOADING_TEXT_KEYS: string[] = [
    'pmwjs_one_click_promo_social_loading_caption',
    'pmwjs_one_click_promo_social_loading_vibe',
    'pmwjs_one_click_promo_social_loading_message',
    'pmwjs_one_click_promo_social_loading_tone',
    'pmwjs_one_click_promo_social_loading_words',
];

export const ONE_CLICK_PROMO_EMAIL_LOADING_TEXT_KEYS: string[] = [
    'pmwjs_one_click_promo_email_loading_subject',
    'pmwjs_one_click_promo_email_loading_hook',
    'pmwjs_one_click_promo_email_loading_opener',
    'pmwjs_one_click_promo_email_loading_clickworthy',
    'pmwjs_one_click_promo_email_loading_subject_alt',
];

export enum OneClickPromoItemState {
    DEFAULT,
    LOADING,
    ERROR,
    SUCCESS,
    WARNING,
    DISABLED
}